import React from "react";
import ReactDOM from "react-dom";
import Gallery from "./Gallery";

ReactDOM.render(<Gallery />, document.getElementById("root"));
